const { Core } = Global;

customElements.define('popup-collection', class extends Core {
    elements = {
        modal: ['modal-container']
    }

    render() {
        // prevents nested modals from closing the popup
        this.$('modal', {'modal-close': this._handleClose } );

      var compatibilityPopupSectionContentTriggerButton = document.querySelector('.compatibility-popup-section-content-trigger-button');
      if (compatibilityPopupSectionContentTriggerButton != null) {
        compatibilityPopupSectionContentTriggerButton.addEventListener("click", function(e) { 
          e.preventDefault();
          if (this.closest('.compatibility-popup-section-content') != null) {
            this.closest('.compatibility-popup-section-content').classList.add('active');
          }
        });
      }

      var compatibilityPopupSectionContentTriggerButtonBack = document.querySelector('.compatibility-popup-section-content-trigger-button-back');
      if (compatibilityPopupSectionContentTriggerButtonBack != null) {
        compatibilityPopupSectionContentTriggerButtonBack.addEventListener("click", function(e) { 
          e.preventDefault();
          if (this.closest('.compatibility-popup-section-content') != null) {
            this.closest('.compatibility-popup-section-content').classList.remove('active');
          }
        });
      }
    }

    _handleClose(e) {
        e.stopPropagation();
    }
});